import React from "react";
import { Link } from "react-router-dom";

const Button = (props) => {
  return (
    <div className="btn-wrap">
      <Link to={props.go} className="btn">
        {props.text}
      </Link>
    </div>
  );
};

export default Button;
